// Import model
import { StartOtgUserCreateFileRequest } from '../models/StartOtgUserCreateFileRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartOtgUserCreateFileRequest - handles JSON serialization and deserialization with type validation
 */
export class StartOtgUserCreateFileRequestSerializer {
  /**
   * Deserializes a JSON string into a StartOtgUserCreateFileRequest instance
   */
  static deserialize(json: string): StartOtgUserCreateFileRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartOtgUserCreateFileRequest instance
   */
  static fromObject(obj: any): StartOtgUserCreateFileRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartOtgUserCreateFileRequest');
    }


    const instance: StartOtgUserCreateFileRequest = {
      fileName: obj['FileName'] as string | undefined,
      contentType: obj['ContentType'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartOtgUserCreateFileRequest instances
   */
  static deserializeArray(json: string): StartOtgUserCreateFileRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartOtgUserCreateFileRequest instance to a JSON string
   */
  static serialize(instance: StartOtgUserCreateFileRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartOtgUserCreateFileRequest instance to a plain object
   */
  static toObject(instance: StartOtgUserCreateFileRequest): any {
    return {
      'FileName': instance.fileName,
      'ContentType': instance.contentType,
    };
  }

  /**
   * Serializes an array of StartOtgUserCreateFileRequest instances to a JSON string
   */
  static serializeArray(instances: StartOtgUserCreateFileRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
